import { Outlet, createRootRoute } from '@tanstack/react-router';

/**
 * Root route. Renders the app shell — everything else is a child route
 * that gets rendered inside the <Outlet />.
 *
 * We deliberately keep this lean: no layout, no navigation. The layout
 * is determined per route tree (authed routes render AuthedLayout, the
 * login route renders its own container).
 */
export const rootRoute = createRootRoute({
  component: RootComponent,
});

function RootComponent(): JSX.Element {
  return <Outlet />;
}
